import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  Privacy: [
    "Wave Eleven respects your privacy. This page explains how we handle information you share with us.",
    "When you submit an enquiry through our contact form, we collect the details you provide — such as your name, business, email, phone number and project information — solely to respond to your enquiry.",
    "We do not sell your data. We do not share it with third parties except where necessary to operate this website and communicate with you.",
    "You can request access to, or deletion of, the information we hold about you at any time by emailing info@waveeleven.co.uk.",
  ],
  Cookies: [
    "This website uses a minimal set of cookies to function correctly and to understand, in aggregate, how visitors use the site.",
    "Essential cookies are required for the website to work. Analytics cookies help us improve the experience and are only ever used in an anonymised, aggregate form.",
    "You can control or disable cookies through your browser settings at any time.",
  ],
  Terms: [
    "These terms govern your use of the Wave Eleven website. By using this website you accept them in full.",
    "All content, design and branding on this website is the property of Wave Eleven unless otherwise stated, and may not be reproduced without permission.",
    "Project engagements are governed by a separate written agreement provided at the point of commissioning work.",
    "For any questions regarding these terms, contact info@waveeleven.co.uk.",
  ],
};

export default function Legal({ kind }) {
  const paras = CONTENT[kind] || [];
  return (
    <>
      <PageHero eyebrow="Legal" title={kind + "."} />
      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[900px] px-6 py-24 md:px-12 md:py-32">
          {paras.map((p, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className="mb-8 text-lg leading-relaxed text-ink/70">{p}</p>
            </Reveal>
          ))}
          <p className="mt-10 text-[11px] uppercase tracking-label text-ink/40">Last updated {new Date().getFullYear()}</p>
        </div>
      </section>
    </>
  );
}
